import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  rowWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  tileHeader: {
    paddingBottom: Theme.px(12),
    paddingLeft: Theme.px(36),
  },
  topRowWrapper: {
    paddingHorizontal: Theme.px(90),
  },
});
